import React, { useCallback, useEffect, useState } from 'react';
const buyers = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Carolina',
  city: 'Córdoba'
}, {
  name: 'Luciana',
  city: 'Rosario'
}, {
  name: 'Valentina',
  city: 'Mendoza'
}, {
  name: 'Florencia',
  city: 'La Plata'
}, {
  name: 'Camila',
  city: 'Mar del Plata'
}, {
  name: 'Julieta',
  city: 'Tucumán'
}, {
  name: 'Sofía',
  city: 'Salta'
}, {
  name: 'Martina',
  city: 'Neuquén'
}, {
  name: 'Paula',
  city: 'Santa Fe'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const showNextBuyer = useCallback(() => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsExiting(false);
    setIsVisible(true);
    setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsExiting(false);
        const nextDelay = Math.floor(Math.random() * 4000) + 8000;
        setTimeout(showNextBuyer, nextDelay);
      }, 400);
    }, 4000);
  }, []);
  useEffect(() => {
    const initialDelay = setTimeout(showNextBuyer, 5000);
    return () => clearTimeout(initialDelay);
  }, [showNextBuyer]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs sm:max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-3 sm:p-4 flex items-start gap-3" style={{
    animation: isExiting ? 'popupSlideOut 0.4s ease-in forwards' : 'popupSlideIn 0.4s ease-out forwards'
  }} data-id="element-189">
      <div className="bg-green-100 rounded-full p-2 flex-shrink-0 mt-1" data-id="element-190">
        <span className="text-lg" data-id="element-191">⭐</span>
      </div>
      <div data-id="element-192">
        <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-193">
          <span className="font-bold" data-id="element-194">{currentBuyer.name}</span> de{' '}
          {currentBuyer.city} acaba de comprar el{' '}
          <span className="font-bold text-yellow-600" data-id="element-195">Plan Premium ⭐</span>
        </p>
        <p className="text-xs text-gray-500 mt-1" data-id="element-196">Hace unos instantes</p>
      </div>
    </div>;
}